module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true,
      "isCloseOnEsc": !_vm.isSubjectModal,
      "isCloseOnBgClick": !_vm.isSubjectModal
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "sdl text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "sdl__header"
  }, [_c('h2', [_vm._v("Brikker på " + _vm._s(_vm.dayTitle))]), _vm._v(" "), _c('div', {
    staticClass: "sdl__header__actions"
  }, [_c('button', {
    ref: "createButton",
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('create')
      }
    }
  }, [_vm._v("Opret flere brikker")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle sdl__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sdl__content"
  }, [(_vm.subjects.length === 0) ? _c('p', {
    staticClass: "sdl__empty"
  }, [_vm._v("Der er ikke oprettet nogen brikker for denne dag endnu.")]) : _c('table', {
    staticClass: "do-table do-table--striped sdl__table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "sdl__col-name"
  }, [_vm._v("Brik")]), _vm._v(" "), _c('th', {
    staticClass: "sdl__col-classes"
  }, [_vm._v("Klasser")]), _vm._v(" "), _c('th', {
    staticClass: "sdl__col-teachers"
  }, [_vm._v("Undervisere")]), _vm._v(" "), _c('th', {
    staticClass: "sdl__col-hours"
  }, [_vm._v("Timer")]), _vm._v(" "), _c('th', {
    staticClass: "sdl__col-actions"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.subjects), function(subject) {
    return _c('tr', {
      key: subject.id
    }, [_c('td', {
      staticClass: "sdl__col-name"
    }, [_c('span', {
      staticClass: "sdl__pill",
      style: ({
        backgroundColor: subject.color
      })
    }, [_vm._v(_vm._s(subject.name))])]), _vm._v(" "), _c('td', {
      staticClass: "sdl__col-classes"
    }, [_vm._v(_vm._s(_vm.classNames(subject) || '–'))]), _vm._v(" "), _c('td', {
      staticClass: "sdl__col-teachers"
    }, [_vm._v(_vm._s(_vm.teacherNames(subject) || '–'))]), _vm._v(" "), _c('td', {
      staticClass: "sdl__col-hours"
    }, [_vm._v(_vm._s(_vm.formatHours(subject.hours)))]), _vm._v(" "), _c('td', {
      staticClass: "sdl__col-actions"
    }, [(_vm.confirmingDeleteId === subject.id) ? [_c('span', {
      staticClass: "sdl__confirm-text"
    }, [_vm._v("Slet brik?")]), _vm._v(" "), _c('button', {
      staticClass: "do-bttn do-bttn--small do-bttn--danger",
      class: {
        'do-bttn--loading': _vm.isDeleting
      },
      attrs: {
        "disabled": _vm.isDeleting
      },
      on: {
        "click": function($event) {
          return _vm.runDelete(subject)
        }
      }
    }, [_vm._v("Slet")]), _vm._v(" "), _c('button', {
      staticClass: "do-bttn do-bttn--small",
      attrs: {
        "disabled": _vm.isDeleting
      },
      on: {
        "click": function($event) {
          _vm.confirmingDeleteId = null
        }
      }
    }, [_vm._v("Fortryd")])] : [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom'
        }),
        expression: "{arrow: true, placement: 'bottom'}"
      }],
      staticClass: "do-bttn do-bttn--small",
      attrs: {
        "aria-label": "Rediger brik",
        "content": 'Rediger brik'
      },
      on: {
        "click": function($event) {
          return _vm.startEdit(subject)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    })]), _vm._v(" "), (_vm.canDeleteSubject(subject)) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom'
        }),
        expression: "{arrow: true, placement: 'bottom'}"
      }],
      staticClass: "do-bttn do-bttn--small do-bttn--danger",
      attrs: {
        "aria-label": "Slet brik",
        "content": 'Slet brik'
      },
      on: {
        "click": function($event) {
          _vm.confirmingDeleteId = subject.id
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })]) : _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom'
        }),
        expression: "{arrow: true, placement: 'bottom'}"
      }],
      staticClass: "do-bttn do-bttn--small do-bttn--disabled",
      attrs: {
        "aria-label": "Kan ikke slettes",
        "disabled": "",
        "content": 'Kan ikke slettes, da brikken er skemalagt'
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])]], 2)])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "sdl__buttons"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    attrs: {
      "disabled": _vm.subjects.length === 0
    },
    on: {
      "click": _vm.openSchedule
    }
  }, [_vm._v("Skemalæg brikker")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Luk")])]), _vm._v(" "), (_vm.isScheduleModal) ? _c('SpecialDayScheduleModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "specialDay": _vm.specialDay,
      "subjects": _vm.subjects,
      "klassCalendars": _vm.klassCalendars
    },
    on: {
      "scheduled": _vm.onScheduled,
      "close": function($event) {
        _vm.isScheduleModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
    attrs: {
      "showModal": _vm.isSubjectModal,
      "editSubject": _vm.editSubject,
      "propIsLoading": _vm.isSubjectLoading,
      "allowDanishPreparationFactorUi": true
    },
    on: {
      "deleteSubject": _vm.handleDeleteSubject,
      "close": _vm.closeSubjectModal,
      "updateSubject": _vm.updateSubject,
      "saveAndShowTab": _vm.saveAndShowTab
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43e2343f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpecialDays/SpecialDaySubjectsListModal.vue
// module id = 1884
// module chunks = 1